import { DynamicLink, MergeData } from '../api-service/clients/auto-generated-clients';

export function dynamicLinksDataMerge(dynamicLinks: DynamicLink[] | undefined, data: MergeData[] | undefined): DynamicLink[] {
  if (dynamicLinks == null) {
    return [];
  }

  const mergedLinks = dynamicLinks.map<DynamicLink>(dynamicLink => mergeDynamicLink(dynamicLink, data));

  return mergedLinks;
}
// A temp object is constructed to hold the merged data before the check for unmerged placeholders
// The check for unmerged placeholders ia a requirement because of garbage links from CRM
function mergeDynamicLink(dynamicLink: DynamicLink, data: MergeData[] | undefined) {
  const dl: DynamicLink = {
    text: replacePlaceholders(data, dynamicLink.text),
    tooltip: replacePlaceholders(data, dynamicLink.tooltip),
    url: replacePlaceholders(data, dynamicLink.url),
    disabled: dynamicLink.disabled,
    postRequestType: dynamicLink.postRequestType,
    autoSubmitPostRequest: dynamicLink.autoSubmitPostRequest,
  };

  return { ...dl, disabled: dl.disabled ? true : containsUnmergedFields(dl) };
}

function replacePlaceholders(dataSet: MergeData[] | undefined, text: string | undefined): string {
  if (!dataSet || !text) {
    return text ?? '';
  }
  let result = text;

  getPlaceholders(text).forEach(placeholder => {
    const mergeData = dataSet.filter(e => e.key?.toLowerCase() === getKeyFromPlaceholder(placeholder));

    if (mergeData.length > 0 && mergeData[0].value) {
      result = result.replace(new RegExp(placeholder, 'g'), mergeData[0].value);
    }
  });

  return result;
}

function getPlaceholders(text: string | undefined): string[] {
  // Find all placeholders like {{name}} and lowercase them

  const placeholdersRegExMatches = text?.match(/{{[a-zA-Z0-9_]+}}/g);

  return placeholdersRegExMatches ? placeholdersRegExMatches.map(placeholder => placeholder) : [];
}

function getKeyFromPlaceholder(placeholder: string): string {
  // Trims start and end for curly brackets
  return placeholder.replace(/^{+|}+$/g, '').toLowerCase();
}

function containsUnmergedFields(dynamicLink: DynamicLink): boolean {
  return getPlaceholders(dynamicLink.text).length > 0 || getPlaceholders(dynamicLink.tooltip).length > 0 || getPlaceholders(dynamicLink.url).length > 0;
}
